import { translate } from '@fiverr-private/i18n-react';

export type PriceDisplayStatus = 'fees' | 'taxes' | 'both' | 'none';

const PRICE_DISPLAY_TRANSLATION_KEYS: Record<PriceDisplayStatus, string> = {
    fees: 'price_regulation_translations.price.plus_fees',
    taxes: 'price_regulation_translations.price.plus_taxes',
    both: 'price_regulation_translations.price.plus_taxes_and_fees',
    none: '',
};

export const regulationTranslation = (status: PriceDisplayStatus): string => {
    const translationKey = PRICE_DISPLAY_TRANSLATION_KEYS[status];
    return translationKey ? translate(translationKey) : '';
};
